import { useCallback } from 'react';

import { useSearchParamsUpdater } from './useSearchParamsUpdater';
import { stripOAuthQueryParams } from '../utils/constants/oauthQueryParams';

export type ClearOAuthParams = (alsoRemove?: readonly string[]) => void;

/**
 * Removes every OAuth callback param and leaves the app's own params alone. Goes through
 * the router rather than `window.history.replaceState`, which leaves React Router's
 * location stale — a later `setSearchParams(prev => …)` merges from `prev` and
 * resurrects what was supposedly removed.
 */
export function useClearOAuthParams(): ClearOAuthParams {
  const updateSearchParams = useSearchParamsUpdater();

  return useCallback(
    (alsoRemove: readonly string[] = []) => {
      updateSearchParams((previous) => {
        const remaining = stripOAuthQueryParams(previous);
        alsoRemove.forEach((name) => remaining.delete(name));
        return remaining;
      });
    },
    [updateSearchParams],
  );
}
